globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};

appCustomerSpace.StepsLoader = (function() {
  function StepsLoader() {}

  StepsLoader.start = function(params) {
    var $container = params.$container;
    var steps = params.steps || [];
    var minDelayMs = params.minDelayMs || 2000;
    var maxDelayMs = params.maxDelayMs || 4000;
    var loaderOptions = params.loaderOptions || {};

    var timeouts = [];

    appCustomerSpace.Loader().start({
      $container: $container,
      options: $.extend(true, {}, loaderOptions)
    });

    var cumulative = 1000;
    steps.forEach(function(step, index) {
      var delay = index === 0 ? 1000 : cumulative;
      timeouts.push(setTimeout(function() {
        appCustomerSpace.Loader().set({
          $container: $container,
          options: $.extend(true, {}, loaderOptions, { text: step })
        });
      }, delay));
      cumulative += randomDelay(minDelayMs, maxDelayMs);
    });

    return {
      stop: function() {
        timeouts.forEach(function(id) { clearTimeout(id); });
        timeouts.length = 0;
        appCustomerSpace.Loader().stop({ $container: $container });
      }
    };
  };

  function randomDelay(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  return StepsLoader;
})();
